(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/card-image.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/card-image.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _React = React,
  useMemo = _React.useMemo;
const Badge = svs.ui.ReactBadge;
const Image = svs.content.image_v2.Image;
const _svs$bingo_react$comp = svs.bingo_react.components.bingoCard,
  CountdownTimer = _svs$bingo_react$comp.CountdownTimer,
  HoverOverlay = _svs$bingo_react$comp.HoverOverlay,
  WinAnim = _svs$bingo_react$comp.WinAnim;
const cmsGames = svs.bingo_react.data.cmsGames;
const CardImage = _ref => {
  let badgeText = _ref.badgeText,
    showTimer = _ref.showTimer,
    startTime = _ref.startTime,
    subTitle = _ref.subTitle,
    title = _ref.title,
    gameId = _ref.gameId,
    _ref$renderHoverOverl = _ref.renderHoverOverlay,
    renderHoverOverlay = _ref$renderHoverOverl === void 0 ? true : _ref$renderHoverOverl,
    status = _ref.status,
    lastWinTimestamp = _ref.lastWinTimestamp;
  const imgSrc = useMemo(() => {
    const cmsData = cmsGames.find(cmsGame => cmsGame.id === gameId);
    if (!cmsData) {
      return null;
    }
    return _objectSpread(_objectSpread({}, cmsData.backgroundImage), {}, {
      fitWrapper: true,
      aspectRatio: {
        height: 720,
        width: 1040
      }
    });
  }, [gameId]);

  const memoizedImage = useMemo(() => {
    if (!imgSrc) return null;
    return React.createElement(Image, {
      cssSelectors: "bingo-card-image-container__image",
      fitWrapper: true,
      image: imgSrc,
      key: "card-image-".concat(gameId)
    });
  }, [gameId]); 

  return React.createElement("div", {
    className: "bingo-card-image-container"
  }, imgSrc ? memoizedImage : React.createElement("div", {
    className: "bingo-card-no-image-container"
  }, badgeText && React.createElement(Badge, {
    branding: "red",
    className: "bingo-card-no-image-container__badge"
  }, badgeText), React.createElement("h3", {
    className: "bingo-card-no-image-container__title"
  }, title), React.createElement("h4", {
    className: "bingo-card-no-image-container__subtitle"
  }, subTitle)), showTimer && React.createElement(CountdownTimer, {
    startTime: startTime,
    status: status
  }), React.createElement(WinAnim, {
    lastWinTimestamp: lastWinTimestamp
  }), renderHoverOverlay && React.createElement(HoverOverlay, {
    gameId: gameId
  }));
};
setGlobal('svs.bingo_react.components.bingoCard.CardImage', CardImage);

 })(window);